import { useDispatch } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { getDepartmentSuccess, start } from "../../store/slices/TeamManagementSlice";
import DepartmentMasterData from "./DepartmentMasterData";
import CreateDepartment from "./CreateDepartment";
import { useState } from "react";

const DepartmentMaster = () => {
    const dispatch = useDispatch();
    const { data } = useFetch('departments');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    if (data.results) {
        dispatch(getDepartmentSuccess(data));
    } else {
        dispatch(start());
    }

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-4 position-relative">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control"
                    />
                    <span className="fa fa-search department-search-icon"></span>
                </div>
                <div className="col-sm-8">
                    <CreateDepartment />
                </div>


            </div>
            <table className="table">
                <thead>
                    <tr>
                        <th onClick={() => handleSort('id')} style={{ width: '160px' }}>Department ID <i class="fa-solid fa-sort"></i> </th>
                        <th onClick={() => handleSort('department_name')}>Department Name <i class="fa-solid fa-sort"></i> </th>
                        <th onClick={() => handleSort('description')}>Department Description <i class="fa-solid fa-sort"></i> </th>
                        <th onClick={() => handleSort('status')} style={{ width: '160px' }}>Department Status <i class="fa-solid fa-sort"></i> </th>
                    </tr>
                </thead>
                <tbody>
                    <DepartmentMasterData searchTerm={searchTerm} sortConfig={sortConfig} />
                </tbody>
            </table>
        </>
    );
};

export default DepartmentMaster;
